import { daysBetweenYmd } from "../../../lib/journeyWindow";
import type { RaceSource } from "../../../lib/raceSources";

/**
 * Muted provenance label for a race's origin (spec §3.4). Returns null when the
 * source is unknown so no line renders.
 */
export function raceSourceLabel(source?: RaceSource): string | null {
  switch (source) {
    case "event":
      return "Saved to your profile";
    case "journey":
      return "From your training plan";
    case "anon_draft":
      return "Draft — not saved yet";
    default:
      return null;
  }
}

/** "Oct 11"-style short date for the drop-strip race chip. */
export function formatYmdShort(ymd: string): string {
  return new Date(`${ymd}T00:00:00Z`).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    timeZone: "UTC"
  });
}

/** Parenthetical relative start hint, e.g. " (in 14 days)" or " (today)". */
export function formatStartInDays(fromYmd: string, startYmd: string): string {
  const days = daysBetweenYmd(fromYmd, startYmd);
  if (days <= 0) return days === 0 ? " (today)" : "";
  if (days === 1) return " (in 1 day)";
  return ` (in ${days} days)`;
}

// Event-row date in the recap — weekday + short date ("Sun Oct 12"), enough to
// sanity-check the race before committing.
export function formatYmdWeekdayShort(ymd: string): string {
  return new Date(`${ymd}T00:00:00Z`).toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: "UTC"
  });
}
